module.exports = __webpack_public_path__ + "media/images/experience-42ce129df59bb92f6d0deee74af36dbf.png";